import Layout from "../../components/reusable/Layout";
import CustomCard from "../../components/reusable/CustomCard";

import classes from "./CoverPage.module.css";

import frontPageBackground from "../../images/frontPageBackground.png";
import coverPageImgLongevity from "../../images/coverPageImgLongevity.png";
import coverPageImgWeightLoss from "../../images/coverPageImgWeightLoss.png";
import coverPageImgPerfomance from "../../images/coverPageImgPerfomance.png";
import coverPageImgStressReport from "../../images/stressReport/coverPageImgStressReport.png";
import CoverPageImgRestore from "../../images/CoverPageImgRestore.png";
import CoverPageImgDiPietroHealth from "../../images/diPietroHealth/coverPageImgDiPetroHealth.png";
import {
  fourthStreetMedicalCoverImg,
  fourthStreetMedicalLogo,
} from "../../images/4thStreetMedical";
import CoverPageImgNaturalSlim from "../../images/naturalSlim/naturalSlimCoverImage.png";
import logo from "../../images/logo.png";
import instagram from "../../images/instagram.png";
import rectangle200 from "../../images/rectangle200.png";
import restore_logo from "../../images/restore_logo.png";
import evityBackgroundImg from "../../images/evity/evityBackgroundImg.png";

// @ts-ignore
import retoImage from "../../images/reto/cover_image_reto.jpeg";
import rncImage from "../../images/rnc/rnc_cover_img.png";
import retoLogo from "../../images/reto/logo_reto.png";
import React, { useEffect, useState } from "react";
import { SvgConverterType } from "../../reports/Report";

interface Props {
  data: {
    AFFILIATE_NAME: string;
    COVER_SUBTITLE: string;
    DATE: string;
    DESCRIPTION: string;
    DISCLAIMER: string;
    IMAGE_URL: string;
    INDEX: number;
    SUBJECT_NAME: string;
    TITLE: string;
    TEST_TYPE: string;
    TEST_TYPE_LABEL: string;
    TEST_DATE_LABEL: string;
  };
  onSvgConverter: SvgConverterType;
  trainerName: string;
  trainerMail: string;
  isRestoreReport?: boolean;
  isRetoReport?: boolean;
  isNaturalSlimReport?: boolean;
  isEvityReport?: boolean;
  isAlluraReport?: boolean;
  isGNCReport?: boolean;
  isDiPietroHealth?: boolean;
  isFourthStreetMedical?: boolean;
  gender?: string;
  reportType: string;
}

const CoverPage = React.memo(
  ({
    data,
    trainerName,
    trainerMail,
    onSvgConverter,

    reportType,
    isRestoreReport,
    isRetoReport,
    isNaturalSlimReport,
    isEvityReport,
    isAlluraReport,
    isGNCReport,
    isDiPietroHealth,
    isFourthStreetMedical,
    gender,
  }: Props): JSX.Element => {
    const [svgReady, setSvgReady] = useState(false);

    useEffect(() => {
      const svgContainer = document.getElementById("main_image_svg");
      if (!svgContainer) return;

      // Set up MutationObserver to watch for SVG injection
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            // Check if any added node contains SVG or is an image element
            const hasNewContent = Array.from(mutation.addedNodes).some(
              (node) =>
                node.nodeType === Node.ELEMENT_NODE &&
                ((node as Element).tagName === "SVG" ||
                  (node as Element).tagName === "IMG" ||
                  (node as Element).querySelector("svg, img"))
            );

            if (hasNewContent) {
              setSvgReady(true);
              observer.disconnect();
            }
          }
        });
      });

      observer.observe(svgContainer, { childList: true, subtree: true });

      // Call the SVG converter
      onSvgConverter("main_image", "main_image_svg", 794);

      // No need to set imgMain anymore

      // Fallback timeout - if SVG isn't detected within 3 seconds, assume it's ready
      const fallbackTimeout = setTimeout(() => {
        setSvgReady(true);
        observer.disconnect();
      }, 3000);

      // Cleanup function
      return () => {
        observer.disconnect();
        clearTimeout(fallbackTimeout);
      };
    }, [onSvgConverter]);

    const logoSrcHandler = (url: string): string => {
      let logoSrc;

      if (isRetoReport) {
        return retoLogo;
      }

      switch (url) {
        case "/logo.svg":
          logoSrc = logo;
          break;
        case "":
          logoSrc = null;
          break;
        default:
          logoSrc = url;
      }
      return logoSrc;
    };

    const backgroundImgHandler = (type: string): string => {
      let backgroundImg: string;

      if (isRetoReport) {
        return retoImage;
      }

      if (isNaturalSlimReport) {
        return CoverPageImgNaturalSlim;
      }

      if (isEvityReport) {
        return evityBackgroundImg;
      }

      if (isGNCReport) {
        return rncImage;
      }

      if (isDiPietroHealth) {
        return CoverPageImgDiPietroHealth;
      }

      if (isFourthStreetMedical) {
        return fourthStreetMedicalCoverImg(type, gender);
      }

      switch (type) {
        case "restore":
          backgroundImg = CoverPageImgRestore;
          break;
        case "10":
        case "11":
          backgroundImg = coverPageImgLongevity;
          break;
        case "12":
        case "13":
          backgroundImg = coverPageImgWeightLoss;
          break;
        case "14":
        case "15":
          backgroundImg = coverPageImgPerfomance;
          break;
        case "16":
          backgroundImg = coverPageImgStressReport;
          break;
        default:
          backgroundImg = coverPageImgLongevity;
      }
      return backgroundImg;
    };

    // Wide banner artwork can't survive the circular crop the portrait covers
    // use: diPietro Health's image is 8475×4163 (2.04:1), so `cover` inside a
    // 650px circle would show a narrow vertical slice out of the middle and
    // throw away most of the picture. Square container plus `contain` fits the
    // whole width in and leaves the spare height empty instead of cropping.
    const isWideBannerCover =
      isRestoreReport || isGNCReport || isDiPietroHealth;

    // 4th Street Medical's covers are photos (mostly ~3:2 landscape), so they
    // fill a rounded rectangle with `cover` — a light crop at the edges rather
    // than the banner's letterboxing, which would leave no edge to round.
    const isRoundedRectCover = !!isFourthStreetMedical;

    const imgFrameStyle = isRoundedRectCover
      ? { width: "690px", height: "460px", borderRadius: "16px" }
      : {
          width: isWideBannerCover ? "730px" : "650px",
          height: "650px",
          borderRadius: isWideBannerCover ? "" : "50%",
        };

    const MainImageItem = (
      <div id="main_image">
        <div
          className={classes.imgContainer}
          style={{
            backgroundImage: `url(${backgroundImgHandler(
              isRestoreReport ? "restore" : reportType
            )})`,
            backgroundSize: isWideBannerCover ? "contain" : "cover",
            // Required by `contain` — the letterboxed rows above and below would
            // otherwise be filled by repeats of the image. A no-op under `cover`,
            // which leaves no empty space to fill.
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            ...imgFrameStyle,
          }}
        />
      </div>
    );

    return (
      <>
        <Layout customPadding={0}>
          <div className={classes.logoContainer}>
            {/*<img className={classes.logo} src={logo} alt="logo" />*/}
          </div>
          <div className={classes.header}>{data.TITLE}</div>
          <div className={classes.subTitle}>{data.COVER_SUBTITLE}</div>
          <CustomCard cardHeight={70} cardWidth="512px" cardPadding="20px 0">
            <div className={classes.subjectName}>{data.SUBJECT_NAME}</div>
          </CustomCard>
          <div
            id="main_image_svg"
            style={{
              height: "650px",
              position: "relative",
              marginTop: "32px",
            }}
          >
            {!svgReady && (
              <div
                className={classes.imageWrapper}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  zIndex: svgReady ? -1 : 1,
                }}
              >
                {MainImageItem}
              </div>
            )}
          </div>

          <div className={classes.bottom}>
            <div className={classes.bottomLeft}>
              <div className={classes.testTypeLabel}>
                {data.TEST_TYPE_LABEL}
                <span>: </span>
              </div>
              <div>{data.TEST_TYPE}</div>
              <div className={classes.testData}>
                <span>{data.TEST_DATE_LABEL}</span>
                <span>: </span>
                <span className={classes.testDateValue}>{data.DATE}</span>
              </div>
            </div>

            {isRestoreReport ? (
              <div className={classes.bottomRightRestore}>
                <div className={classes.logoRestoreContainer}>
                  <img
                    alt="restore logo"
                    src={restore_logo}
                    className={classes.logoRestore}
                  />
                </div>
                <div className={classes.testDateValue}>
                  Restore Hyper Wellness
                </div>
              </div>
            ) : (
              <div className={classes.bottomRight}>
                <div className={classes.logo2Container}>
                  {!!data.IMAGE_URL && (
                    <img
                      className={classes.logo2}
                      src={logoSrcHandler(data.IMAGE_URL)}
                      alt="logo"
                    />
                  )}
                </div>

                <div className={classes.affiliateName}>
                  {data.AFFILIATE_NAME}
                </div>
                <div className={classes.affiliateName}>{trainerMail}</div>
              </div>
            )}
          </div>
          {/*<div className={classes.footer}>*/}
          {/*  <div>www.pnoe.com</div>*/}
          {/*  <div className={classes.instagram}>*/}
          {/*    <img src={instagram} alt="logo" />*/}
          {/*    <span>pnoe_analytics</span>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </Layout>
        <Layout customPadding={0} isEvityReport={isEvityReport}>
          <img
            className={classes.backgroundImg}
            src={frontPageBackground}
            alt="background of the front page"
          />
          <img
            className={classes.rectangle200}
            src={rectangle200}
            alt="background of the description"
          />
          <div id="coverDescription" className={classes.description}>
            <div className={classes.disclaimer}>
              <span>{`${data.DISCLAIMER} `}</span>
              {data.DESCRIPTION}
              {isAlluraReport && (
                <div style={{ marginTop: "8px" }}>
                  This report is based on health and wellness testing and is
                  intended for informational purposes and not for the diagnosis
                  of any disease. Treatment recommendations included are
                  determined solely by AlluraMD using their professional
                  judgment.
                </div>
              )}
              {isGNCReport && (
                <div
                  style={{
                    marginTop: "8px",
                    fontFamily: "AktivGroteskEx_A_Md",
                  }}
                >
                  This report is intended for educational and wellness purposes
                  only and does not constitute medical advice, diagnosis, or
                  treatment. The nutritional, supplementation, exercise, and
                  lifestyle recommendations provided are designed to support
                  general health and metabolic performance. Dietary supplements
                  are not intended to diagnose, treat, cure, or prevent any
                  disease. Customers are encouraged to consult with their
                  physician before starting any nutrition, supplementation, or
                  exercise program. The metabolic assessment is provided as part
                  of our performance and wellness program and results may vary
                  depending on individual adherence and lifestyle factors.
                </div>
              )}
            </div>
          </div>
          {isFourthStreetMedical && (
            <img
              className={classes.fourthStreetMedicalLogo}
              src={fourthStreetMedicalLogo}
              alt="4th Street Medical logo"
            />
          )}
        </Layout>
      </>
    );
  }
);

export default CoverPage;
